export const COUNTRIES = [
  "India",
  "United States",
  "United Kingdom",
  "Canada",
  "Australia",
  "Germany",
  "France",
  "Netherlands",
  "Spain",
  "Italy",
  "Sweden",
  "Switzerland",
  "Norway",
  "Denmark",
  "Ireland",
  "United Arab Emirates",
  "Saudi Arabia",
  "Qatar",
  "Kuwait",
  "Singapore",
  "Malaysia",
  "Indonesia",
  "Thailand",
  "Philippines",
  "Vietnam",
  "Japan",
  "South Korea",
  "China",
  "Hong Kong",
  "Taiwan",
  "South Africa",
  "Nigeria",
  "Kenya",
  "Egypt",
  "Brazil",
  "Mexico",
  "Argentina",
  "Chile",
  "New Zealand",
  "Turkey",
  "Other...",
];

export const INDIA_STATES_AND_UTS = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export const INDUSTRIES = [
  "E-commerce",
  "Retail",
  "Healthcare",
  "Education",
  "Real Estate",
  "Travel & Hospitality",
  "Finance & Insurance",
  "IT & Software Services",
  "Manufacturing",
  "Logistics & Transportation",
  "Professional Services",
  "Media & Entertainment",
  "Food & Beverage",
  "Automotive",
  "Beauty & Wellness",
  "Nonprofit",
  "Government",
  "Other",
];
